module.exports = __webpack_public_path__ + "img/resultado-isf.3a21de0b.svg";